import React from 'react';
import { Button } from '@farmers-fridge/ui-library';
import SignUpModal from './SignUpModal';
import useModal from '../../utils/useModal';
import styles from './Banner.module.css';

/**
 * @param {object} props
 * @param {object} props.data
 * @param {string=} props.data.ctaText
 * @param {string=} props.data.headline
 * @param {string} props.data.contentful_id
 * @param {object} props.data.modal
 * @param {string=} props.data.modal.headline
 * @param {string=} props.data.modal.emailPlaceholder
 * @param {string=} props.data.modal.phonePlacholder
 * @param {string=} props.data.modal.buttonCta
 * @param {object} props.data.modal.image
 * @param {string=} props.data.modal.image.description
 * @param {import('gatsby-plugin-image').IGatsbyImageData=} props.data.modal.image.gatsbyImageData
 * @param {import('gatsby-source-contentful/rich-text.d').RenderRichTextData<import('gatsby-source-contentful/rich-text.d').ContentfulRichTextGatsbyReference>} props.data.modal.helpText
 * @param {import('gatsby-source-contentful/rich-text.d').RenderRichTextData<import('gatsby-source-contentful/rich-text.d').ContentfulRichTextGatsbyReference>} props.data.modal.confirmationText
 * @param {string=} props.data.modal.apiEndpoint
 * @param {string} props.data.modal.contentful_id
 */

export default function Banner({ data }) {
  const [isShowing, toggle] = useModal();

  return (
    <div>
      <div className={styles.promoBarWrapper}>
        <h2>{data?.headline}</h2>
        <Button buttonType="primary" className={styles.button} onClick={toggle}>
          {data?.ctaText}
        </Button>
      </div>
      {isShowing && (
        <SignUpModal
          data={data.modal}
          toggle={toggle}
          banner={data.contentful_id}
        />
      )}
    </div>
  );
}
